import { useTranslation } from 'react-i18next';
import { TypedTranslation, TranslationKey, NavigationKey, FormsKey } from './types';

/**
 * Enhanced useTranslation hook with TypeScript support and multiple namespaces
 */
export const useTypedTranslation = (): TypedTranslation & { i18n: any } => {
  const { t: tCommon, i18n } = useTranslation('common');
  const { t: tNavigation } = useTranslation('navigation');
  const { t: tForms } = useTranslation('forms');

  return {
    t: (key: TranslationKey, options?: any) => tCommon(key, options),
    tNav: (key: NavigationKey, options?: any) => tNavigation(key, options),
    tForm: (key: FormsKey, options?: any) => tForms(key, options),
    i18n,
  };
};

/**
 * Hook for language switching functionality
 */
export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = async (languageCode: string) => {
    try {
      await i18n.changeLanguage(languageCode);
      localStorage.setItem('i18n-language', languageCode);
    } catch (error) {
      console.error('Failed to change language:', error);
    }
  };

  return {
    currentLanguage: i18n.language,
    changeLanguage,
    isReady: i18n.isInitialized,
  };
};